/**
 * 解析后端验证错误，返回用户友好的错误信息
 * @param {Object} error - axios 错误对象
 * @param {Object} fieldMap - 字段名映射表，如 { nickname: '昵称', phone: '手机号' }
 * @returns {string} 用户友好的错误信息
 */
export const parseValidationError = (error, fieldMap = {}) => {
  // 默认字段映射
  const defaultFieldMap = {
    'nickname': '昵称',
    'password_hash': '密码',
    'real_name': '真实姓名',
    'gender': '性别',
    'phone': '手机号',
    'email': '邮箱',
    'id_card': '身份证号码',
    'role': '角色',
    'avatar_url': '头像',
    'idcard_url': '身份证照片',
    'education': '学历',
    'marital_status': '婚姻状况',
    'order_city': '接单城市',
    'old_password_hash': '原密码',
    'new_password_hash': '新密码',
  };

  // 合并用户提供的映射
  const mergedFieldMap = { ...defaultFieldMap, ...fieldMap };

  // 422 验证错误
  if (error.response?.status === 422 && error.response?.data?.detail) {
    const errors = error.response.data.detail;
    if (Array.isArray(errors) && errors.length > 0) {
      // 收集所有错误信息
      const errorMessages = errors.map(err => {
        const fieldName = mergedFieldMap[err.loc?.[1]] || err.loc?.[1] || '字段';
        const errorMessage = err.msg || '格式错误';

        // 根据错误类型提供更具体的提示
        if (err.type === 'string_too_short') {
          const minLen = err.ctx?.min_length;
          return `${fieldName}太短${minLen ? `，至少需要${minLen}个字符` : ''}`;
        } else if (err.type === 'string_too_long') {
          const maxLen = err.ctx?.max_length;
          return `${fieldName}太长${maxLen ? `，最多${maxLen}个字符` : ''}`;
        } else if (err.type === 'value_error') {
          return errorMessage;
        } else if (err.type === 'missing') {
          return `请填写${fieldName}`;
        } else {
          return `${fieldName}：${errorMessage}`;
        }
      });

      // 返回所有错误，用换行分隔
      return errorMessages.join('\n');
    }
  }

  // 400 等业务错误（如"该昵称已被使用"）
  if (error.response?.data?.detail) {
    return error.response.data.detail;
  }

  // 网络错误等
  if (error.message) {
    return error.message;
  }

  return '操作失败，请重试';
};

/**
 * 小程序版本的错误解析
 */
export const parseValidationErrorMini = (error, fieldMap = {}) => {
  const defaultFieldMap = {
    'nickname': '昵称',
    'password_hash': '密码',
    'real_name': '真实姓名',
    'gender': '性别',
    'phone': '手机号',
    'email': '邮箱',
    'id_card': '身份证号码',
    'role': '角色',
    'avatar_url': '头像',
    'idcard_url': '身份证照片',
    'education': '学历',
    'marital_status': '婚姻状况',
    'order_city': '接单城市',
    'old_password_hash': '原密码',
    'new_password_hash': '新密码',
  };

  const mergedFieldMap = { ...defaultFieldMap, ...fieldMap };

  // wx.request 的错误格式
  const data = error.data || error.err?.data;

  if (error.statusCode === 422 && data?.detail) {
    const errors = data.detail;
    if (Array.isArray(errors) && errors.length > 0) {
      const errorMessages = errors.map(err => {
        const fieldName = mergedFieldMap[err.loc?.[1]] || err.loc?.[1] || '字段';
        const errorMessage = err.msg || '格式错误';

        if (err.type === 'string_too_short') {
          const minLen = err.ctx?.min_length;
          return `${fieldName}太短${minLen ? `，至少需要${minLen}个字符` : ''}`;
        } else if (err.type === 'string_too_long') {
          const maxLen = err.ctx?.max_length;
          return `${fieldName}太长${maxLen ? `，最多${maxLen}个字符` : ''}`;
        } else if (err.type === 'value_error') {
          return errorMessage;
        } else if (err.type === 'missing') {
          return `请填写${fieldName}`;
        } else {
          return `${fieldName}：${errorMessage}`;
        }
      });

      return errorMessages.join('\n');
    }
  }

  if (data?.detail) {
    return data.detail;
  }

  return '操作失败，请重试';
};
